import { motion } from "framer-motion";
import { EASE, VARIANTS } from "./motion";

export const Reveal = ({ children, delay = 0, className = "", variant = "up", duration = 0.8, ...rest }) => (
  <motion.div
    className={className}
    variants={VARIANTS[variant]}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, amount: "some" }}
    transition={{ duration, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

// Eyebrow label drawn like a CAD dimension line: tick — line — tick, then the text.
export const Eyebrow = ({ children, className = "" }) => (
  <motion.p
    className={`flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] text-stone-500 ${className}`}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, amount: 0.5 }}
  >
    <motion.span
      aria-hidden="true"
      className="relative block h-2 w-10 shrink-0 origin-left before:absolute before:left-0 before:top-0 before:h-2 before:w-px before:bg-current after:absolute after:right-0 after:top-0 after:h-2 after:w-px after:bg-current"
      variants={{ hidden: { scaleX: 0 }, show: { scaleX: 1 } }}
      transition={{ duration: 0.7, ease: EASE }}
    >
      <span className="absolute left-0 right-0 top-1 h-px bg-current" />
    </motion.span>
    <motion.span variants={{ hidden: { opacity: 0 }, show: { opacity: 1 } }} transition={{ duration: 0.5, delay: 0.3 }}>{children}</motion.span>
  </motion.p>
);
